import { render, staticRenderFns } from "./RuleTable.vue?vue&type=template&id=bfa308da&scoped=true"
import script from "./RuleTable.vue?vue&type=script&lang=js"
export * from "./RuleTable.vue?vue&type=script&lang=js"
import style0 from "./RuleTable.vue?vue&type=style&index=0&id=bfa308da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa308da",
  null
  
)

export default component.exports